'use strict';

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require('jquery');
// TODO: v pripade, ze je pouzit linksoft/core/localize, tak za nejakych zatim nezjistenych duvodu se neprovede initializace pro nasledne vytvoreni instance localize()


// in search adv
//$(".form-slider").slider({});

// datepicker
//$.fn.datepicker.dates['cs'] = {
//	days: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
//	daysShort: ["Ned", "Pon", "Úte", "Stř", "Čtv", "Pát", "Sob"],
//	daysMin: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
//	months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
//	monthsShort: ["Led", "Úno", "Bře", "Dub", "Kvě", "Čer", "Čnc", "Srp", "Zář", "Říj", "Lis", "Pro"],
//	today: "Dnes",
//	clear: "Vymazat",
//	weekStart: 1,
//	format: "dd.m.yyyy"
//};

//$('.input-daterange input').each(function() {
//    $(this).datepicker({
//    	language: 'cs'
//    });
//});


Dropzone.options.oneFileUploadDropzone = {
	maxFiles: 1,
	dictDefaultMessage: (0, _localize2.default)("App:DragFilesOrClickHere"),
	dictMaxFilesExceeded: (0, _localize2.default)("App:NumberOfUploadedFilesExceeded")
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/main.js
// module id = 1191
// module chunks = 0